/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
// import ChildTraining from "components/widgets/training/CompletedTraining";
import { connect } from "react-redux";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import requireAuth from "components/hoc/requireAuth";
import DesktopBreakpoint from "util/responsive/desktop_breakpoint";
import TabletBreakpoint from "util/responsive/tablet_breakpoint";
import { Trans } from "react-i18next";

class PositionRole extends Component {
  rowClassName = "";
  state = {
    showingChildren: false,
  };

  componentDidMount() {}

  componentDidUpdate(prevProps, prevState) {}

  toggleChildren = () => {
    let showingChildren = this.state.showingChildren;
    this.setState({ showingChildren: !showingChildren });
  };

  renderTabletModeDetail = (role) => {
    if (!this.state.showingChildren) {
      return null;
    }
    return (
      <tr className="child">
        <td className="child" colSpan="2">
          <table>
            <tbody>
              <tr data-dt-row="0" data-dt-column="1">
                <td>
                  <div className="tableTitle">
                    <Trans desc="Eğitim">10596</Trans>
                  </div>
                </td>
                <td className="showGrup">{role.training ? role.training.name : ""}</td>
              </tr>
              <tr data-dt-row="0" data-dt-column="1">
                <td>
                  <div className="tableTitle">
                    <Trans desc="Yeterlilik">10596</Trans>
                  </div>
                </td>
                <td className="showGrup">{role.qualification ? role.qualification.toFixed(2) : ""}</td>
              </tr>
            </tbody>
          </table>
        </td>
      </tr>
    );
  };

  render() {
    const { role } = this.props;
    return (
      <>
        {this.props.spinner}
        <DesktopBreakpoint>
          <tr>
            <td className="showGrup">{role.position ? role.position.name : ""}</td>
            <td className="showGrup">{role.role ? role.role.name : ""}</td>
            <td className="showGrup">{role.training ? role.training.name : ""}</td>
            <td className="showGrup">{role.qualification ? role.qualification.toFixed(2) : ""}</td>
            <td className="showGrup">{role.formattedMethod ? role.formattedMethod : ""}</td>
          </tr>
        </DesktopBreakpoint>
        <TabletBreakpoint>
          <tr
            className={this.rowClassName}
            onClick={() => this.toggleChildren()}
          >
            <td className="showGrup">{role.position ? role.position.name : ""}</td>
            <td className="showGrup">{role.role ? role.role.name : ""}</td>
          </tr>
          {this.renderTabletModeDetail(role)}
        </TabletBreakpoint>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

export default connect(mapStateToProps, {})(
  containsLongRunningProcess(requireAuth(PositionRole))
);
